// Atom node for chat-bot skill pills rendered inside the editor.
//
// HTML shape: <span data-skill="landing-pages:build">/landing-pages:build</span>
//
// Rendered as a non-editable, selectable pill; the `/command` label lives
// inside the span, so when the message is serialized and later converted to
// markdown for the LLM, the text survives even though the `data-skill`
// attribute is dropped.

import { mergeAttributes } from '@tiptap/core'
import Mention from '@tiptap/extension-mention'
import suggestion from './chat_bot_skill_suggestion'

export const ChatBotSkill = Mention.extend({
  name: 'chatBotSkill',

  addOptions() {
    const parent = this.parent?.() ?? {}

    return {
      ...parent,
      skills: [],
      suggestion: {
        ...parent.suggestion,
        char: '/',
        allow: (props) =>
          props.range.from === 1 && parent.suggestion.allow(props),
        command: ({ editor, range, props }) => {
          editor
            .chain()
            .focus()
            .insertContentAt(range, [
              { type: 'chatBotSkill', attrs: { name: props.name } },
              { type: 'text', text: ' ​' },
            ])
            .run()
        },
      },
    }
  },

  addAttributes() {
    return {
      name: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-skill'),
        renderHTML: (attributes) => {
          if (!attributes.name) return {}
          return { 'data-skill': attributes.name }
        },
      },
    }
  },

  renderText({ node }) {
    return `/${node.attrs.name}`
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      `/${node.attrs.name}`,
    ]
  },
}).configure({
  HTMLAttributes: {
    class: 'chat-bot-skill',
  },
  suggestion,
})
